import * as Styled from './BulletedList.styled';
import type { BulletedListProps } from './BulletedList.typed';
import React from 'react';
import { BulletedListItem } from './BulletedListItem/BulletedListItem';

export const BulletedList = (props: BulletedListProps) => {
  const {
    children,
    className,
    color = 'GREY_DARK',
    fontSize = 'M16',
    gap,
  } = props;
  return (
    <Styled.BulletedList className={className} $color={color} $gap={gap}>
      {children.map((text, index) => (
        <BulletedListItem key={index} fontSize={fontSize}>
          {text}
        </BulletedListItem>
      ))}
    </Styled.BulletedList>
  );
};
